"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyDoubleUpdater = void 0;
var sum_1 = require("./sum");
var applyDoubleUpdater = function (updaters, outerUpdater, innerUpdater) {
    return function (containerState) { return (0, sum_1.deconstruct)(function (l) { return outerUpdater(l); }, function (r) { return innerUpdater(r); }, updaters)(containerState); };
};
exports.applyDoubleUpdater = applyDoubleUpdater;
